import { MonitorPlay, Usb, Settings, ScanLine, CheckCircle2, Download, Smartphone } from "lucide-react";
import { Button } from "../components/ui/button";

const steps = [
  { icon: Settings, title: "1. Enable Unknown Sources", body: "On the Samsung Android TV, go to Settings → Security & Restrictions → Unknown Sources and turn it ON. This lets you install the Player app." },
  { icon: Usb, title: "2. Install the Player APK", body: "Copy the SignageHub Player APK to a USB drive (or use the download link). Plug it into the TV, open the file manager, and install the APK. Or, simply open the web Player in the TV browser." },
  { icon: MonitorPlay, title: "3. Open the Player", body: "Launch the Player once. It auto-starts on boot and reconnects automatically if WiFi drops. The screen will show a 6-digit pairing code." },
  { icon: ScanLine, title: "4. Pair in the Dashboard", body: "On the TV Wall, click \"Add TV\", enter the 6-digit code, give the TV a name (e.g. \"Dairy Section\") and a zone. That's it — paired forever." },
  { icon: CheckCircle2, title: "5. Push Content", body: "Upload media, build a playlist, assign it to the TV or zone, and it plays instantly. Use Instant Push for flash offers, and the Ticker for live text overlays." },
];

export default function Guide() {
  const playerUrl = `${window.location.origin}/tv.html`;
  return (
    <div className="p-6 md:p-8 max-w-3xl">
      <h1 className="text-3xl font-display font-bold tracking-tight mb-1">Installation Guide</h1>
      <p className="text-sm text-muted-foreground mb-6">Get a new Samsung TV online in minutes</p>

      {/* APK download — the recommended install */}
      <div className="bg-card border border-border rounded-md p-5 mb-4">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded bg-primary/15 flex items-center justify-center flex-shrink-0">
            <Smartphone className="w-6 h-6 text-primary" />
          </div>
          <div className="flex-1">
            <h3 className="font-display font-semibold text-lg">SignHub Player — Android TV App</h3>
            <p className="text-sm text-muted-foreground mt-1">
              Installs as <span className="text-foreground font-medium">"SignageHub Player"</span> in your TV's app list.
              Auto-starts on power-on, reconnects on WiFi drop, runs full-screen. Works on <span className="text-foreground">all Android TVs (Android 5.0+)</span> and Android TV boxes / Fire TV sticks.
            </p>
            <div className="flex flex-wrap items-center gap-3 mt-4">
              <a href="/AVTechSignhub.apk" download data-testid="download-apk">
                <Button className="h-11"><Download className="w-4 h-4 mr-2" /> Download APK (v1.0)</Button>
              </a>
              <span className="text-xs text-muted-foreground font-mono">com.signagehub.player · Android 5.0+</span>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-secondary/40 border border-border rounded-md p-4 mb-6">
        <p className="text-xs uppercase tracking-wider text-muted-foreground mb-1">Works on every other Smart TV too (Samsung Tizen, LG webOS, etc.) — open this URL in the TV's browser</p>
        <p className="font-mono text-primary text-base break-all" data-testid="player-url">{playerUrl}</p>
      </div>

      <div className="space-y-4">
        {steps.map((s, i) => (
          <div key={i} className="flex gap-4 bg-card border border-border rounded-md p-4 fade-up">
            <div className="w-10 h-10 rounded bg-secondary flex items-center justify-center flex-shrink-0">
              <s.icon className="w-5 h-5 text-primary" />
            </div>
            <div>
              <h3 className="font-display font-semibold">{s.title}</h3>
              <p className="text-sm text-muted-foreground mt-1">{s.body}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
